import {styled} from '@linaria/react';
import React from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

interface ColorLabelProps {
  className?: string;
  'data-testid'?: string;
  label: string;
  name: string;
}

export const ColorLabel: React.FC<ColorLabelProps> = ({
  'data-testid': dataTestid,
  label,
  name,
  ...rest
}) => (
  <ColorContainer {...rest}>
    <span data-testid={`${dataTestid}Label`}>{label}</span>
    {label && <span>: </span>}
    <ColorName data-testid={`${dataTestid}SelectedOptionName`}>
      {name}
    </ColorName>
  </ColorContainer>
);

const ColorContainer = styled.div`
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.bold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ColorName = styled.span`
  font-weight: ${FONT_WEIGHTS.mediumBold};
`;
